import { controller } from "./controller";

@controller
export default class PrintSaveButtonElement extends HTMLElement {
  printSave(): void {
    window.print();
  }
}

declare global {
  interface Window {
    PrintSaveButtonElement: typeof PrintSaveButtonElement;
  }
  interface HTMLElementTagNameMap {
    "print-save-button": PrintSaveButtonElement;
  }
}

if (!window.customElements.get("print-save-button")) {
  window.PrintSaveButtonElement = PrintSaveButtonElement;
  window.customElements.define("print-save-button", PrintSaveButtonElement);
}
